import { render, staticRenderFns } from "./view-model.vue?vue&type=template&id=47c75800&scoped=true&lang=html"
import script from "./view-model.vue?vue&type=script&lang=js"
export * from "./view-model.vue?vue&type=script&lang=js"
import style0 from "./view-model.vue?vue&type=style&index=0&id=47c75800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c75800",
  null
  
)

export default component.exports